import { render, staticRenderFns } from "./privateHot.vue?vue&type=template&id=7f6cf5f9"
import script from "./privateHot.vue?vue&type=script&lang=js"
export * from "./privateHot.vue?vue&type=script&lang=js"
import style0 from "./privateHot.vue?vue&type=style&index=0&id=7f6cf5f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports